var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 16,
    viewBox: "0 0 49 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7463 15.7451H8.60628L5.50176 3.90118C5.35441 3.35636 5.04154 2.87471 4.58131 2.6477C3.43276 2.07722 2.16714 1.6232 0.786453 1.39422V0.938229H7.45571C8.37617 0.938229 9.06651 1.6232 9.18156 2.41872L10.7924 10.9621L14.9304 0.938229H18.9553L12.7463 15.7451ZM21.2565 15.7451H17.3466L20.5661 0.938229H24.4761L21.2565 15.7451ZM29.5345 5.04012C29.6496 4.24263 30.3399 3.78664 31.1453 3.78664C32.4109 3.67215 33.7896 3.90113 34.9401 4.46964L35.6305 1.28165C34.4799 0.825662 33.2143 0.59668 32.0657 0.59668C28.2709 0.59668 25.5095 2.64765 25.5095 5.49413C25.5095 7.65959 27.4655 8.79661 28.8462 9.48158C30.3399 10.1646 30.9152 10.6206 30.8001 11.3036C30.8001 12.3281 29.6496 12.7841 28.501 12.7841C27.1203 12.7841 25.7396 12.4426 24.476 11.8721L23.7857 15.062C25.1664 15.6305 26.6601 15.8595 28.0408 15.8595C32.2959 15.972 34.9401 13.923 34.9401 10.8476C34.9401 6.97462 29.5345 6.74761 29.5345 5.04012V5.04012ZM48.6239 15.7451L45.5193 0.938229H42.1847C41.4944 0.938229 40.804 1.39422 40.5739 2.07722L34.8251 15.7451H38.8501L39.6535 13.5816H44.5989L45.0591 15.7451H48.6239ZM42.76 4.92571L43.9085 10.5062H40.689L42.76 4.92571Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.ca18108038c63a8a47396146b8c62ff2.svg";
export { ForwardRef as ReactComponent };